import { render, staticRenderFns } from "./AdvertisementPopup.vue?vue&type=template&id=a2708d24&scoped=true"
import script from "./AdvertisementPopup.vue?vue&type=script&lang=js"
export * from "./AdvertisementPopup.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementPopup.vue?vue&type=style&index=0&id=a2708d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2708d24",
  null
  
)

export default component.exports